/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */

import { Component, Input, } from '@angular/core';

@Component({
    selector: 'app-cm-product-box',
    templateUrl: './cm-product-box.component.html',
    styleUrls: ['./cm-product-box.component.scss'],
})
export class CmProductBoxComponent {
    /**
     * Set the size of the product
     */
    @Input() public size: 'small' | 'medium' | 'large' = 'large';

    /**
     * Set to show the box setup is complete/
     */
    @Input() set complete(state: boolean) {
        this._complete = state;
    }

    /**
     * Private variable for getter setter.
     * @private
     */
    private _complete: boolean = false;

    constructor() {
    }

    get complete() {
        return this._complete;
    }

}
